import * as Sentry from '@sentry/vue';

const config = useRuntimeConfig();
const router = useRouter();
const app = useNuxtApp();

Sentry.init({
    app: app.vueApp,
    dsn: config.public.sentryDsnPublic ?? null,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.browserProfilingIntegration(),
        Sentry.httpClientIntegration(),
        Sentry.vueIntegration({
            // Track all vue components
            tracingOptions: {
                trackComponents: true,
            },
        }),
    ],
    environment: config.public.sentryEnvironment,
    release: config.public.sentryRelease,
    debug: config.public.sentryDebug,
    enabled: !config.public.sentryDisabled,

    // https://docs.sentry.io/platforms/javascript/guides/vue/enriching-events/context/
    // To ensure that event data is sufficiently complete
    normalizeDepth: 5,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: config.public.sentryTracesSampleRate,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [config.public.frontendBaseUrl, config.public.backendApiBaseUrl],

    // Integration HttpClient
    // This option is required for capturing headers and cookies.
    sendDefaultPii: true,
});
